export const SITE_CORE_COOKIE_NOT_IN_HEADER = "E_SINGLESIGNONSESSIONS_SITECORECOOKIENOTINHEADER";
